import { Pto } from '@outcoreaix/pto'
import { apiSlice } from './api-splice'

export const chatsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createChat: builder.mutation<Pto.Chats.Chat, Pto.Chats.CreateChat>({
      query: (data) => ({
        url: 'chats',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['Chats']
    }),
    getChats: builder.query<Pto.Chats.ChatList, Pto.Chats.ChatListQuery>({
      query: (params) => ({
        url: 'chats',
        method: 'GET',
        params
      }),
      providesTags: ['Chats']
    }),
    getChatMessages: builder.query<Pto.Chats.ChatMessagesList, Pto.Chats.ChatMessageListQuery & { chatId: number }>({
      query: ({ chatId, ...rest }) => ({
        url: `chats/${chatId}/messages`,
        method: 'GET',
        params: rest
      }),
      providesTags: ['ChatMessages']
    }),
    getChatCSV: builder.query<Pto.Chats.ChatCsv, Pto.Chats.ChatCsvQuery & { chatId: number }>({
      query: ({ chatId, ...rest }) => ({
        url: `chats/${chatId}/csv`,
        method: 'GET',
        params: rest
      }),
      providesTags: ['ChatMessages']
    }),
    sendMessageFeedback: builder.mutation<Pto.Chats.MessageFeedback, Pto.Chats.CreateMessageFeedback>({
      query: (data) => ({
        url: 'chats/message-feedback',
        method: 'POST',
        body: data
      })
    }),
    deleteChat: builder.mutation<void, number>({
      query: (chatId) => ({
        url: `chats/${chatId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Chats', 'ChatMessages']
    }),
    deleteMessagesInRange: builder.mutation<void, { spaceId: number; startDate: Date; endDate: Date }>({
      query: ({ spaceId, startDate, endDate }) => ({
        url: `spaces/${spaceId}/delete-messages-in-range`,
        method: 'POST',
        body: { startDate, endDate }
      })
    })
  })
})

export const {
  useGetChatMessagesQuery,
  useGetChatCSVQuery,
  useCreateChatMutation,
  useGetChatsQuery,
  useSendMessageFeedbackMutation,
  useDeleteChatMutation,
  useDeleteMessagesInRangeMutation
} = chatsApi
